/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StoreProfileImageRequest
 */
export interface StoreProfileImageRequest {
    /**
     * 
     * @type {string}
     * @memberof StoreProfileImageRequest
     */
    imageKey: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileImageRequest
     */
    filename: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileImageRequest
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileImageRequest
     */
    contentType: string;
}

/**
 * Check if a given object implements the StoreProfileImageRequest interface.
 */
export function instanceOfStoreProfileImageRequest(value: object): value is StoreProfileImageRequest {
    if (!('imageKey' in value) || value['imageKey'] === undefined) return false;
    if (!('filename' in value) || value['filename'] === undefined) return false;
    if (!('contentType' in value) || value['contentType'] === undefined) return false;
    return true;
}

export function StoreProfileImageRequestFromJSON(json: any): StoreProfileImageRequest {
    return StoreProfileImageRequestFromJSONTyped(json, false);
}

export function StoreProfileImageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreProfileImageRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'imageKey': json['imageKey'],
        'filename': json['filename'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'contentType': json['contentType'],
    };
}

export function StoreProfileImageRequestToJSON(json: any): StoreProfileImageRequest {
    return StoreProfileImageRequestToJSONTyped(json, false);
}

export function StoreProfileImageRequestToJSONTyped(value?: StoreProfileImageRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'imageKey': value['imageKey'],
        'filename': value['filename'],
        'imageUrl': value['imageUrl'],
        'contentType': value['contentType'],
    };
}

